import { render, staticRenderFns } from "./ScreenGroupSidebar.vue?vue&type=template&id=920f84be&scoped=true"
import script from "./ScreenGroupSidebar.vue?vue&type=script&lang=js"
export * from "./ScreenGroupSidebar.vue?vue&type=script&lang=js"
import style0 from "./ScreenGroupSidebar.vue?vue&type=style&index=0&id=920f84be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920f84be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('920f84be')) {
      api.createRecord('920f84be', component.options)
    } else {
      api.reload('920f84be', component.options)
    }
    module.hot.accept("./ScreenGroupSidebar.vue?vue&type=template&id=920f84be&scoped=true", function () {
      api.rerender('920f84be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/ScreenGroupSidebar.vue"
export default component.exports